import React, { useState } from "react";
import { Modal, Form, Button, Input, message} from "antd";
import Service from "./../../../utils/apiOpen";

function LyDoTuChoi(props) {
  const [form] = Form.useForm();
  const formRef = React.createRef();
  const [loading, setLoading] = useState(false);
  const { TextArea } = Input;

  const onFinish = (val) => {
    form
      .validateFields()
      .then(async (values) => {
        Suspension(values)
      })
      .catch((err) => {
        console.error("err:", err);
      });
  };

  const Suspension = async (values) => {
    setLoading(true);
    const dataForm = {
      "uid": props?.detail?.uid || undefined,
      "status": 'dang_hoat_dong' || undefined,
      "reasonForRejection": values?.note || undefined
    }
    await Service.openApiCall("PATCH", `/v1/affiliate/portal/product`, dataForm)
      .then((res) => {
        setLoading(false);
        let data = res?.data;
        if (data.success) {
          props.MessageSucces('Từ Chối Duyệt Ngừng Bán Sản Phẩm..');
          props.getList();
          props.handleCancel();
        }
      })
      .catch((err) => {
        setLoading(false);
        if (err?.response) {
          message.error(err?.response?.data?.error?.statusCode + '|' + err?.response?.data?.message);
        }
      });
  };

  return (
    <Modal
      open={true}
      onCancel={() => props.handleCancel()}
      footer={null}
      centered
      width={450}
      title="Lý do từ chối duyệt"
    >
      <Form
        ref={formRef}
        scrollToFirstError
        form={form}
        onFinish={onFinish}
        autoComplete="off"
        layout={'vertical'}
        requiredMark={false}
      >
        <Form.Item
          // label={<div><span><b>Nhập số seri đã bán</b></span><sup style={{ color: 'red' }}>*</sup></div>}
          name="note"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập thông tin",
            },
          ]}
          style={{ margin: 0, marginTop: 5 }}
        >
          <TextArea
            placeholder="Nhập nội dung..."
            rows={4}
            showCount={false}
            style={{ marginTop: 8 }}
          />
        </Form.Item>
        <div style={{ textAlign: "right", marginTop: 16 }}>
          <Button
            loading={loading}
            htmlType="submit"
            type="primary"
            style={{ backgroundColor: "#0B7CE4", border: "none" }}
          >
            Tiếp tục
          </Button>
        </div>
      </Form>

    </Modal>
  );
}

export default LyDoTuChoi;
